import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Paper, Typography, Card, Grid, Box, LinearProgress, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { reputationManagementReviewStatistics,
         reputationManagementReview,
         reputationManagementList
 } from '../../../redux/actions/Network/ReputationManagement/ReputationManagement.actions';
import { Backdrop, Container} from "@material-ui/core";
import { REPUTATION_MANAGEMENT, CONTENT } from "../../../constants/appUrls.constants";
import { PageTitle } from "../../atomic/PageHeader/PageTitle";
import PageHeaderAtm from "../../atomic/PageHeader/PageHeader"
import { Animated } from "react-animated-css";
import ButtonAtm from "../../atomic/Button/Button";
import ColAtm from "../../atomic/Col/Col";
import {Menu, MenuItem, IconButton, Tooltip} from "@material-ui/core";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip as ChartTooltip,
    Legend,
    Filler
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { getProperty } from "../../../utils";
import NotAllowedPage from "../Global/NotAllowedPage/NotAllowedPage";

// Chart.js kayıt
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    ChartTooltip,
    Legend,
    Filler
);

const useStyles = makeStyles((theme) => ({
    statisticsCard: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(3),
        borderRadius: 16,
        background: '#ffffff',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    },
    scoreCircle: {
        width: 140,
        height: 140,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 32,
        fontWeight: 'bold',
        color: '#fff',
        margin: '0 auto',
        position: 'relative',
        boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
        '&::before': {
            content: '""',
            position: 'absolute',
            width: 160,
            height: 160,
            borderRadius: '50%',
            border: '3px solid',
            borderColor: 'inherit',
            opacity: 0.3,
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: 180,
            height: 180,
            borderRadius: '50%',
            border: '2px dashed',
            borderColor: 'inherit',
            opacity: 0.2,
            animation: '$rotate 20s linear infinite',
        },
    },
    '@keyframes rotate': {
        '0%': { transform: 'rotate(0deg)' },
        '100%': { transform: 'rotate(360deg)' },
    },
    scoreSection: {
        borderRadius: 16,
        padding: theme.spacing(4),
        position: 'relative',
        overflow: 'hidden',
        minHeight: 280,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    scoreSectionDecor: {
        position: 'absolute',
        width: 200,
        height: 200,
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.05)',
        top: -80,
        left: -80,
    },
    scoreSectionDecor2: {
        position: 'absolute',
        width: 150,
        height: 150,
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,0.05)',
        bottom: -50,
        right: -50,
    },
    scoreSectionTitle: {
        color: 'rgba(0, 0, 0, 0.9)',
        fontWeight: 600,
        marginBottom: theme.spacing(4),
        textAlign: 'center',
    },
    scoreValue: {
        fontSize: 36,
        fontWeight: 700,
    },
    categorySection: {
        padding: theme.spacing(2),
    },
    categorySectionTitle: {
        fontWeight: 600,
        color: '#333',
        marginBottom: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        '&::before': {
            content: '""',
            width: 4,
            height: 24,
            backgroundColor: '#667eea',
            borderRadius: 2,
            marginRight: theme.spacing(1.5),
        },
    },
    categoryScore: {
        marginBottom: theme.spacing(2),
        padding: 16,
        borderRadius: 10,
        backgroundColor: '#f8f9fc',
        transition: 'all 0.3s ease',
        '&:hover': {
            backgroundColor: '#f0f2f8',
            transform: 'translateX(4px)',
        },
    },
    progressBar: {
        height: 8,
        borderRadius: 4,
    },
    barGreen: {
        backgroundColor: '#4caf50 !important',
    },
    barOrange: {
        backgroundColor: '#ff9800 !important',
    },
    barRed: {
        backgroundColor: '#f44336 !important',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#d71f26',
    },
    showAllButton: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: '#fff',
        border: 'none',
        borderRadius: 8,
        padding: '10px 28px',
        fontWeight: 600,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
        },
    },
    // Chart Card Styles
    chartCard: {
        padding: theme.spacing(2.5),
        borderRadius: 12,
        backgroundColor: '#fff',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        height: '100%',
        transition: 'all 0.3s ease',
        '&:hover': {
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            transform: 'translateY(-2px)',
        },
    },
    chartHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 20,
    },
    chartTitle: {
        fontSize: 14,
        fontWeight: 600,
        color: '#333',
        marginBottom: 4,
    },
    chartScore: {
        fontSize: 28,
        fontWeight: 700,
        color: '#333',
        lineHeight: 1,
    },
    chartChange: {
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 600,
        padding: '2px 8px',
        borderRadius: 12,
        marginLeft: 8,
    },
    chartChangePositive: {
        backgroundColor: 'rgba(76, 175, 80, 0.1)',
        color: '#4caf50',
    },
    chartChangeNegative: {
        backgroundColor: 'rgba(244, 67, 54, 0.1)',
        color: '#f44336',
    },
    chartSubtitle: {
        fontSize: 12,
        color: '#888',
        marginTop: 2,
    },
    chartContainer: {
        height: 120,
        marginTop: theme.spacing(1),
    },
    chartsSection: {
        marginTop: theme.spacing(4),
    },
    chartsSectionTitle: {
        fontWeight: 600,
        color: '#333',
        marginBottom: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        '&::before': {
            content: '""',
            width: 4,
            height: 24,
            backgroundColor: '#764ba2',
            borderRadius: 2,
            marginRight: theme.spacing(1.5),
        },
    },
    // View Toggle Buttons
    viewToggleContainer: {
        display: 'flex',
        gap: 4,
    },
    viewToggleBtn: {
        padding: 6,
        borderRadius: 6,
        minWidth: 'unset',
        backgroundColor: '#f5f5f5',
        color: '#999',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#e8e8e8',
        },
    },
    viewToggleBtnActive: {
        backgroundColor: '#667eea',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#5a6fd6',
        },
    },
    // Table Styles
    miniTable: {
        marginTop: theme.spacing(1),
        maxHeight: 140,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: 4,
        },
        '&::-webkit-scrollbar-track': {
            background: '#f1f1f1',
            borderRadius: 4,
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#c1c1c1',
            borderRadius: 4,
        },
    },
    miniTableCell: {
        padding: '6px 8px',
        fontSize: 12,
        borderBottom: '1px solid #f0f0f0',
    },
    miniTableHead: {
        backgroundColor: '#f8f9fc',
        '& th': {
            fontWeight: 600,
            color: '#555',
            fontSize: 11,
            padding: '8px',
        },
    },
    miniTableRow: {
        '&:hover': {
            backgroundColor: '#fafafa',
        },
    },
}));

// Mini Chart Bileşeni
const CategoryMiniChart = ({ category, classes, t, statisticsData }) => {
    const [viewMode, setViewMode] = useState('chart'); // 'chart' veya 'table'

    // scoreMonthlyGroup verisini
    const scoreMonthlyGroup = category?.scoreMonthlyGroup || {};

    // Tarihe göre sırala (eskiden yeniye) ve 0 olanları filtrele
    const sortedEntries = Object.entries(scoreMonthlyGroup)
        .sort((a, b) => new Date(a[0]) - new Date(b[0]))
        .slice(-10);

    const labels = sortedEntries.map(([date]) => {
        // YYYY-MM formatını ay/yıl olarak göster
        const [year, month] = date.split('-');
        return `${month}/${year}`;
    });

    const values = sortedEntries.map(([, value]) => value);

    // Değişim hesapla
    const lastValue = values[values.length - 1] || 0;
    const prevValue = values[values.length - 2] || lastValue;
    const change = lastValue - prevValue;
    const changePercent = prevValue !== 0 ? ((change / prevValue) * 100).toFixed(1) : 0;

    // scoreMonthlyGroupAverage kullan
    const averageScore = category?.scoreMonthlyGroupAverage;

    // Renk belirle - averageScore kullan
    const getLineColor = (score) => {
        if (score >= 80) return '#4caf50';
        if (score >= 60) return '#ff9800';
        return '#f44336';
    };

    const lineColor = getLineColor(averageScore);

    const chartData = {
        labels,
        datasets: [
            {
                data: values,
                borderColor: lineColor,
                backgroundColor: `${lineColor}20`,
                borderWidth: 2,
                fill: true,
                tension: 0.4,
                pointRadius: 0,
                pointHoverRadius: 4,
                pointHoverBackgroundColor: lineColor,
                pointHoverBorderColor: '#fff',
                pointHoverBorderWidth: 2,
            },
        ],
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 8,
                bottom: 0,
                left: 0,
                right: 0
            },
            margin: {
                top: 10
            }
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
                backgroundColor: 'rgba(0,0,0,0.8)',
                titleFont: { size: 11 },
                bodyFont: { size: 12, weight: 'bold' },
                padding: 8,
                displayColors: false,
                callbacks: {
                    title: (items) => {
                        if (items.length > 0) {
                            const idx = items[0].dataIndex;
                            const date = sortedEntries[idx]?.[0];
                            if (date) {
                                // YYYY-MM formatını ay/yıl olarak göster
                                const [year, month] = date.split('-');
                                return `${month}/${year}`;
                            }
                        }
                        return '';
                    },
                    label: (item) => `${item.raw}%`,
                },
            },
        },
        scales: {
            x: {
                display: false,
            },
            y: {
                display: false,
                min: 0,
                max: 105,
            },
        },
        interaction: {
            intersect: false,
            mode: 'index',
        },
    };

    const categoryName = t(category?.language_key ?? category?.name);

    return (
        <Paper className={classes.chartCard} elevation={0}>
            <Box className={classes.chartHeader}>
                <Box>
                    <Typography className={classes.chartTitle}>
                        {categoryName}
                    </Typography>
                    <Box display="flex" alignItems="center">
                        <Typography className={classes.chartScore}>
                            {averageScore?.toFixed(0)}%
                        </Typography>
                        {change !== 0 && (
                            <span className={`${classes.chartChange} ${change >= 0 ? classes.chartChangePositive : classes.chartChangeNegative}`}>
                                <i className={`fas fa-arrow-${change >= 0 ? 'up' : 'down'}`} style={{ fontSize: 10, marginRight: 3 }} />
                                {Math.abs(changePercent)}%
                            </span>
                        )}
                    </Box>
                </Box>
                {/* View Toggle Buttons */}
                <Box className={classes.viewToggleContainer}>
                    <Tooltip PopperProps={{ disablePortal: true }} title={<span style={{fontSize: "16px", color: "inherit" }}>{t('enw-reputation_management-chart_view')}</span>} arrow>
                        <IconButton 
                            size="small"
                            className={`${classes.viewToggleBtn} ${viewMode === 'chart' ? classes.viewToggleBtnActive : ''}`}
                            onClick={() => setViewMode('chart')}
                        >
                            <i className="fas fa-chart-line" style={{ fontSize: 14 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip PopperProps={{ disablePortal: true }} title={<span style={{fontSize: "16px", color: "inherit" }}>{t('enw-reputation_management-stats_view')}</span>} arrow>
                        <IconButton 
                            size="small"
                            className={`${classes.viewToggleBtn} ${viewMode === 'table' ? classes.viewToggleBtnActive : ''}`}
                            onClick={() => setViewMode('table')}
                        >
                            <i className="fas fa-table" style={{ fontSize: 14 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
            <Box style={{ position: 'relative', minHeight: 140 }}>
                <Box
                    className={classes.chartContainer}
                    style={{
                        display: viewMode === 'chart' ? 'block' : 'none',
                        position: viewMode === 'chart' ? 'relative' : 'absolute',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0,
                    }}
                >
                    <Line data={chartData} options={chartOptions} />
                </Box>
                <Box
                    className={classes.miniTable + " rm-scores-mini-table"}
                    style={{
                        display: viewMode === 'table' ? 'flex' : 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: viewMode === 'table' ? 'relative' : 'absolute',
                        width: '100%',
                        height: '100%',
                        top: 30,
                        left: 0,
                        padding: 16,
                        fontSize: 28,
                        fontWeight: 700
                    }}
                >
                    {(() => {
                        const reviewCategoryScoreBySystem = statisticsData?.reviewCategoryScoreBySystem || [];
                        const categoryObj = reviewCategoryScoreBySystem.find(
                            c => (c.language_key || c.name) === (category.language_key || category.name)
                        );
                        const positiveTotal = categoryObj?.positive ?? 0;
                        const negativeTotal = categoryObj?.negative ?? 0;

                        return (
                            <>
                                <Box display="flex" alignItems="center">
                                    <i className="far fa-thumbs-up" style={{color: "#4caf50", fontSize: 36, marginRight: 10}} />
                                    <span style={{fontWeight: 700, fontSize: 32}}>{positiveTotal}</span>
                                </Box>
                                <span style={{fontSize: 32, fontWeight: 400, margin: "0 18px"}}>|</span>
                                <Box display="flex" alignItems="center">
                                    <i className="far fa-thumbs-down" style={{color: "#f44336", fontSize: 36, marginRight: 10}} />
                                    <span style={{fontWeight: 700, fontSize: 32}}>{negativeTotal}</span>
                                </Box>
                            </>
                        );
                    })()}
                </Box>
            </Box>
        </Paper>
    );
};

export default function ReputationManagementScores() {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const propertyProductsReducer = useSelector(state => state.propertyProductsReducer);
    const allowedPageReputationManagement = !propertyProductsReducer.fetching &&
        propertyProductsReducer.get_products &&
        Object.values(propertyProductsReducer.get_products.data).filter(item => "reputation-management" === item.route);

    const statisticsData = useSelector(state => state.reputationManagementReducer?.reviewStatisticsData);
    const statisticsFetching = useSelector(state => state.reputationManagementReducer?.reviewStatisticsFetching);
    const reviewData = useSelector(state => state.reputationManagementReducer?.reviewData);
    const reviewFetching = useSelector(state => state.reputationManagementReducer?.reviewFetching);
    const channelListData = useSelector(state => state.reputationManagementReducer?.listData);
    const channelListFetching = useSelector(state => state.reputationManagementReducer?.fetching);
    
    const [showAllCategories, setShowAllCategories] = useState(false);
    const [showAllCharts, setShowAllCharts] = useState(false);

    const [anchorElFilter, setAnchorElFilter] = useState(null);
    const [selectedChannel, setSelectedChannel] = useState(null);
    const [sortDesc, setSortDesc] = useState(true);
    const [anchorElSort, setAnchorElSort] = useState(null);

    const categories = statisticsData?.reviewCategoryScoreBySystem?.slice().sort((a, b) => ((b.negative + b.positive) - (a.negative + a.positive))) || [];
    const visibleCategories = showAllCategories ? categories : categories.slice(0, 9);
    const visibleChartCategories = showAllCharts ? categories : categories.slice(0, 6);

    const sortedCategories = [...categories]
    .filter(category => category?.scoreMonthlyGroupAverage !== null && category?.scoreMonthlyGroupAverage !== undefined)
    .sort((a, b) => sortDesc 
        ? (b.scoreMonthlyGroupAverage || 0) - (a.scoreMonthlyGroupAverage || 0) 
        : (a.scoreMonthlyGroupAverage || 0) - (b.scoreMonthlyGroupAverage || 0)
    );

    const visibleChartSortedCategories = showAllCharts ? sortedCategories : sortedCategories.slice(0, 6);

    useEffect(() => {
        dispatch(reputationManagementReview({ page: 1, per_page: 100 }));
    }, [dispatch]);

    useEffect(() => {
        dispatch(reputationManagementList());
    }, [dispatch]);

    useEffect(() => {
        if (selectedChannel) {
            dispatch(reputationManagementReviewStatistics({ channel_id: selectedChannel.id }));
        } else {
            dispatch(reputationManagementReviewStatistics());
        }
    }, [dispatch, selectedChannel]);

    const getScoreColor = (score) => {
        if (score >= 80) return '#00796b';
        if (score >= 60) return '#4caf50';
        if (score >= 40) return '#ffeb3b';
        if (score >= 20) return '#ff9800';
        return '#f44336';
    };

    const getBarColorClass = (score) => {
        if (score >= 80) return classes.barGreen;
        if (score >= 60) return classes.barOrange;
        return classes.barRed;
    };

    const getScoreGradient = (score) => {
        if (score >= 80) return 'linear-gradient(135deg, #00796b 0%, #38ef7d 100%)';
        if (score >= 60) return 'linear-gradient(135deg, #4caf50 0%, #a8e063 100%)';
        if (score >= 40) return 'linear-gradient(135deg, #ffeb3b 0%, #ffe259 100%)';
        if (score >= 20) return 'linear-gradient(135deg, #ff9800 0%, #ffc371 100%)';
        return 'linear-gradient(135deg, #f44336 0%, #ff6a6a 100%)';
    };

    if (statisticsFetching) {
        return (
            <Backdrop className={classes.backdrop} open={true}>
                <CircularProgress className='rm-circular-proggress' color="inherit" />
            </Backdrop>
        );
    }

    const totalReviews = statisticsData?.dashboard?.total?.count || "-";
    const totalReviewsCount = statisticsData?.dashboard?.total?.extraReviewCount ?? null;

    const positiveReviews =  statisticsData?.dashboard?.positive?.count || '-';
    const positiveReviewsCount =  statisticsData?.dashboard?.positive?.extraReviewCount ?? null;

    const negativeReviews = statisticsData?.dashboard?.negative?.count || '-';
    const negativeReviewsCount = statisticsData?.dashboard?.negative?.extraReviewCount ?? null;

    let mostCommentedScoreName = statisticsData?.dashboard?.best?.language_key ?? statisticsData?.dashboard?.best?.name ?? null; 
    let mostCommentedScore = statisticsData?.dashboard?.best?.positive;

    const systemScore = statisticsData?.reviewScoreBySystem;

    const scoredCategories = categories.filter(category => category?.score !== null && category?.score !== undefined);

    const openFilterMenu = (e) => setAnchorElFilter(e.currentTarget);
    const closeFilterMenu = () => setAnchorElFilter(null);

    const applyChannelFilter = (channel) => {
        setSelectedChannel(channel);
        closeFilterMenu();
        dispatch(reputationManagementReview({
            page: 1,
            per_page: 100,
            channel_id: channel?.id || null
        }));
        dispatch(reputationManagementReviewStatistics({ channel_id: channel?.id || null }));
    };

    const clearChannelFilter = () => {
        setSelectedChannel(null);
        closeFilterMenu();
        dispatch(reputationManagementReview({ page: 1, per_page: 100 }));
        dispatch(reputationManagementReviewStatistics());
    };

    const openSortMenu = (e) => setAnchorElSort(e.currentTarget);
    const closeSortMenu = () => setAnchorElSort(null);

    const handleSortChange = (desc) => {
        setSortDesc(desc);
        closeSortMenu();
    };

    const channels = Array.isArray(channelListData) ? channelListData : [];

    if (!propertyProductsReducer.fetching && (!allowedPageReputationManagement[0] || !allowedPageReputationManagement[0].property_has_product)) {
        return (
            <Grid item xs={12} lg={6} className="no-buy-product">
                <Card className="p-24">
                    <NotAllowedPage />
                </Card>
            </Grid>
        );
    }

    return (
        <>
            <PageTitle title={t('enw-reputation_management-title') + " - " + t('enw-reputation_management_scores-title')} />
                <PageHeaderAtm 
                    backButton={REPUTATION_MANAGEMENT} 
                    exitText={t('btn-dashboard')} 
                    text={t('enw-reputation_management_scores-title')}
                />
            <Animated animationIn="bounceInRight" animationInDuration={1000} isVisible={true}>
                <Container maxWidth="xl">
                    <div className="container-width">
                        <Grid container className="mb-16 cpa-button-container" spacing={3}>
                            <Grid item xs={12} md={1} className="cpa-top-buttons-left"></Grid>
                            <Grid item xs={12} md={11} className="cpa-top-buttons" style={{paddingRight: 0, paddingLeft: 0}}>
                                <ButtonAtm
                                    className="inventory-action-btn bg-dark-orange inventory-filter-box"
                                    buttontext={ selectedChannel ? `${t('enw-table-toolbar-filters')}: ${selectedChannel.name}` : t('enw-table-toolbar-filters')}
                                    startIcon={<i style={{fontSize: "14px", marginTop: "2px"}} className="fas fa-filter" />}
                                    onClick={openFilterMenu}
                                    endIcon={<i className="fas fa-chevron-down" style={{ fontSize: 12 }}></i>}
                                />                            
                                <Menu
                                    anchorEl={anchorElFilter}
                                    open={Boolean(anchorElFilter)}
                                    onClose={closeFilterMenu}
                                >
                                    <MenuItem
                                        onClick={clearChannelFilter}
                                        style={{
                                            color: !selectedChannel ? '#f44336' : undefined,
                                            fontWeight: !selectedChannel ? 700 : undefined
                                        }}
                                        disabled={!selectedChannel}
                                    >
                                        {t('btn-see_all')}
                                    </MenuItem>
                                    {channels?.map(ch => (
                                        <MenuItem
                                            key={ch?.id}
                                            selected={selectedChannel?.id === ch?.id}
                                            disabled={selectedChannel?.id === ch?.id}
                                            onClick={() => applyChannelFilter(ch)}
                                            style={{
                                                color: selectedChannel?.id === ch?.id ? '#fff' : undefined,
                                                backgroundColor: selectedChannel?.id === ch?.id ? '#f44336' : undefined,
                                                fontWeight: selectedChannel?.id === ch?.id ? 700 : undefined
                                            }}
                                        >
                                            {ch?.logoUrl &&
                                                <img
                                                    src={ch?.logoUrl}
                                                    alt={ch?.name}
                                                    style={{ width: 65, height: 35, marginRight: 8, verticalAlign: "middle", borderRadius: 4 }}
                                                />
                                            }
                                            {ch?.name}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Grid>
                        </Grid>

                        {/* KPI Cards */}
                        <Grid container spacing={3} className="mb-24">
                            <Grid item xs={6} sm={3}>
                                <Paper className="offer-boxes">
                                    <Box display="flex" flexDirection="column" alignItems="center" className="pt-26">
                                        <i className="fas fa-comments-alt blue fs-22 bg-icon-blue m-auto b-r-50" />
                                        <span className="payment-info-text m-auto f-w-bold">
                                            {reviewFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{totalReviews}</>}
                                        </span>
                                        <ColAtm sm={12}>
                                            <span className="offer-total-title"> {t('enw-reputation_management-total_reviews')} </span>
                                        </ColAtm>
                                        {
                                            totalReviewsCount && totalReviewsCount !== 0 ?
                                            <ColAtm justify={"center"} sm={12}>
                                                <span style={{ color: "#1976d2", fontSize: 14 }}>+{totalReviewsCount}</span>
                                            </ColAtm> : ""
                                        }
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Paper className="offer-boxes">
                                    <Box display="flex" flexDirection="column" alignItems="center" className="pt-26">
                                        <i className="far fa-thumbs-up green fs-22 bg-icon-green m-auto b-r-50" />
                                        <span className="payment-info-text m-auto f-w-bold">
                                            {statisticsFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{positiveReviews}</>}
                                        </span>
                                        <ColAtm sm={12}>
                                            <span className="offer-total-title"> {t('enw-reputation_management-positive_total_scores')} </span>
                                        </ColAtm>
                                        {
                                            positiveReviewsCount && positiveReviewsCount !== 0 ?
                                            <ColAtm justify={"center"} sm={12}>
                                                <span style={{ color: "#4caf50", fontSize: 14 }}>+{positiveReviewsCount}</span>
                                            </ColAtm> : ""
                                        }
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Paper className="offer-boxes">
                                    <Box display="flex" flexDirection="column" alignItems="center" className="pt-26">
                                        <i className="far fa-thumbs-down red fs-22 bg-icon-red m-auto b-r-50" />
                                        <span className="payment-info-text m-auto f-w-bold">
                                            {statisticsFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{negativeReviews}</>}
                                        </span>
                                        <ColAtm sm={12}>
                                            <span className="offer-total-title"> {t('enw-reputation_management-negative_total_scores')} </span>
                                        </ColAtm>
                                        {
                                            negativeReviewsCount && negativeReviewsCount !== 0 ?
                                            <ColAtm justify={"center"} sm={12}>
                                                <span style={{ color: "#4caf50", fontSize: 14 }}>+{negativeReviewsCount}</span>
                                            </ColAtm> : ""
                                        }
                                    </Box>
                                </Paper>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Paper className="offer-boxes">
                                    <Box display="flex" flexDirection="column" alignItems="center" className="pt-26">
                                        <i className="fas fa-trophy-alt fs-22 bg-icon-yellow m-auto b-r-50" style={{color: "gold"}} />
                                        <span className="payment-info-text m-auto f-w-bold">
                                            {statisticsFetching ? <CircularProgress className="rm-circular-progress" color="secondary" /> : <>{mostCommentedScore === 0 ? '-' : mostCommentedScore}</>}
                                        </span>
                                        <span className="offer-total-title">
                                            {t('enw-reputation_management-most_commented_score')}
                                        </span>
                                        <span className="offer-total-title" style={{ color: "#1976d2", fontSize: 14, fontWeight: 700 }}>
                                            {t(mostCommentedScoreName)}
                                        </span>
                                    </Box>
                                </Paper>
                            </Grid>
                        </Grid>

                        {/* System Score & Category Scores */}
                        <Box mt={2}>
                            {(systemScore || categories.length > 0) ? (
                                <Paper className={classes.statisticsCard} elevation={0}>
                                    <Grid container spacing={3} alignItems="stretch">
                                        {/* System Score Section */}
                                        <Grid item xs={12} md={3} style={{ display: "flex", alignItems: "stretch", justifyContent: "center" }}>
                                            <Box className={classes.scoreSection} style={{ width: "100%", height: "100%" }}>
                                                <div className={classes.scoreSectionDecor}></div>
                                                <div className={classes.scoreSectionDecor2}></div>
                                                <Typography variant="h6" className={classes.scoreSectionTitle}>
                                                    {/* {t('enw-reputation_management-system_score')} */}
                                                </Typography>
                                                    {
                                                        selectedChannel ? 
                                                        <img alt={selectedChannel?.name ?? 'Provider Logo'} style={{width: "50%", height: "auto", marginBottom: 30}} src={selectedChannel?.logoUrl} />
                                                        :
                                                        <img alt={"Extranetwork"} style={{width: "70%", height: "auto", marginBottom: 30}} src={'/assets/img/logo/logo.png'} />
                                                    }
                                                <Box 
                                                    className={classes.scoreCircle} 
                                                    style={{ 
                                                        background: getScoreGradient(systemScore),
                                                        borderColor: getScoreColor(systemScore),
                                                        marginTop: 10
                                                    }}
                                                >
                                                    <span className={classes.scoreValue}>
                                                        {systemScore?.toFixed(1)}%
                                                    </span>
                                                </Box>
                                                <Box mt={4} display="flex" justifyContent="center" alignItems="center">
                                                    <Box 
                                                        px={2} 
                                                        py={0.5} 
                                                        borderRadius={20} 
                                                        style={{ 
                                                            backgroundColor: 'rgba(255,255,255,0.2)',
                                                            color: '#000000ff',
                                                            fontSize: 12,
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {/* {systemScore >= 80 ? t('enw-reputation_management-excellent') : 
                                                        systemScore >= 60 ? t('enw-reputation_management-good') : 
                                                        t('enw-reputation_management-needs_improvement')} */}
                                                        <span className="d-block" style={{fontStyle: "italic", color: "#666", fontWeight: 500 }}>{t('enw-reputation_management-data_shows_from_date')}</span>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>

                                        {/* Category Scores Section */}
                                        <Grid item xs={12} md={9}>
                                            <Box className={classes.categorySection}>
                                                <Typography variant="h6" className={classes.categorySectionTitle}>
                                                    {t('enw-reputation_management-category_scores')} 
                                                </Typography>
                                                <Grid container spacing={2}>
                                                    {visibleCategories
                                                        .filter(category => category?.score !== null && category?.score !== undefined)
                                                        .map((category, index) => (
                                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                                <Box className={classes.categoryScore}>
                                                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={0.5}>
                                                                        <Typography className={classes.categoryName}>
                                                                            {t(category?.language_key ?? category?.name)}
                                                                        </Typography>
                                                                        <Typography className={classes.categoryValue}>
                                                                            {category?.score?.toFixed(0)}%
                                                                        </Typography>
                                                                    </Box>
                                                                    <LinearProgress
                                                                        variant="determinate"
                                                                        value={category?.score}
                                                                        className={classes.progressBar}
                                                                        classes={{
                                                                            bar: getBarColorClass(category?.score)
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Grid>
                                                        ))}
                                                    {scoredCategories.length > 9 && !showAllCategories && (
                                                        <Grid item xs={12}>
                                                            <Box display="flex" justifyContent="center" mt={3}>
                                                                <ButtonAtm
                                                                    className={classes.showAllButton}
                                                                    buttontext={t('btn-see_all')}
                                                                    endIcon={<i className="fas fa-chevron-down" style={{ fontSize: 12 }}></i>}
                                                                    onClick={() => setShowAllCategories(true)}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                    {showAllCategories && scoredCategories.length > 9 && (
                                                        <Grid item xs={12}>
                                                            <Box display="flex" justifyContent="center" mt={3}>
                                                                <ButtonAtm
                                                                    className={classes.showAllButton}
                                                                    buttontext={t('btn-show_less')}
                                                                    endIcon={<i className="fas fa-chevron-up" style={{ fontSize: 12 }}></i>}
                                                                    onClick={() => setShowAllCategories(false)}
                                                                />
                                                            </Box>
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            ): (
                                <Paper className={classes.statisticsCard} elevation={0}>
                                    <Box className={classes.emptyState}>
                                        <i className={`fas fa-chart-pie ${classes.emptyIcon}`} />
                                        <Typography variant="h6" style={{ fontWeight: 500, color: '#666' }}>
                                            {t('enw-cpa-data_not_found')}
                                        </Typography>
                                        <Typography variant="body2" style={{ color: '#999', marginTop: 8 }}>
                                            {t('enw-reputation_management-no_data_description')}
                                        </Typography>
                                    </Box>
                                </Paper>
                            )}
                        </Box>

                        {/* Category Charts Section */}
                        {sortedCategories.length > 0 && (
                            <Box className={classes.chartsSection}>
                                <Paper className={classes.statisticsCard} elevation={0}>
                                    <Box display="flex" alignItems="center" justifyContent="space-between" className="rm-charts-section" mb={2}>
                                        <Box display="flex" alignItems="center">
                                            <Typography variant="h6" className={classes.chartsSectionTitle} style={{marginBottom: 0}}>
                                                {t('enw-reputation_management-category_trends')}
                                            </Typography>
                                            {selectedChannel && (
                                                <img
                                                    alt={selectedChannel?.name ?? 'Provider Logo'}
                                                    style={{ width: "100px", height: "50px", marginLeft: 8 }}
                                                    src={selectedChannel?.logoUrl}
                                                />
                                            )}
                                        </Box>
                                        <Box>
                                            <ButtonAtm
                                                className="inventory-action-btn bg-dark-orange chart-sort-btn"
                                                buttontext={sortDesc ? t('btn-rm-sort-desc') : t('btn-rm-sort-asc')}
                                                startIcon={<i className={`fas fa-sort-amount-${sortDesc ? 'down' : 'up'}`} />}
                                                onClick={openSortMenu}
                                                style={{ marginLeft: 16, minWidth: 340, fontSize: 13, padding: "4px 12px" }}
                                                endIcon={<i className="fas fa-chevron-down" style={{ fontSize: 12 }}></i>}
                                            />
                                            <Menu
                                                anchorEl={anchorElSort}
                                                open={Boolean(anchorElSort)}
                                                onClose={closeSortMenu}
                                            >
                                                <MenuItem
                                                    selected={sortDesc}
                                                    onClick={() => handleSortChange(true)}
                                                    style={{textTransform: "capitalize"}}
                                                >
                                                    <i className="fas fa-sort-amount-down" style={{ marginRight: 8 }} />
                                                    {t('btn-rm-sort-desc')}
                                                </MenuItem>
                                                <MenuItem
                                                    selected={!sortDesc}
                                                    onClick={() => handleSortChange(false)}
                                                    style={{textTransform: "capitalize"}}
                                                >
                                                    <i className="fas fa-sort-amount-up" style={{ marginRight: 8 }} />
                                                    {t('btn-rm-sort-asc')}
                                                </MenuItem>
                                            </Menu>
                                        </Box>
                                    </Box>
                                    <span className="d-block last-twelve-month-text" style={{marginBottom: 24, fontStyle: "italic", color: "#666" }}>{t('enw-reputation_management-data_shows_from_date')}</span>
                                    <Grid container spacing={3}>
                                        {visibleChartSortedCategories.map((category, index) => (
                                            <Grid item xs={12} sm={6} md={4} key={index}>
                                                <CategoryMiniChart 
                                                    category={category} 
                                                    classes={classes} 
                                                    t={t}
                                                    statisticsData={statisticsData}
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                    {sortedCategories.filter(c => c.score !== null && c.score !== undefined).length > 3 && sortedCategories.length > 6 && (
                                        <Box display="flex" justifyContent="center" mt={4}>
                                            <ButtonAtm
                                                className={classes.showAllButton}
                                                buttontext={showAllCharts ? t('btn-show_less') : t('btn-see_all')}
                                                endIcon={<i className={`fas fa-chevron-${showAllCharts ? 'up' : 'down'}`} style={{ fontSize: 12 }}></i>}
                                                onClick={() => setShowAllCharts(!showAllCharts)}
                                            />
                                        </Box>
                                    )}
                                </Paper>
                            </Box>
                        )}
                    </div>
                </Container>
            </Animated>
            <style>{`
                @media (max-width: 767px) {
                    .container-width {
                        min-height: 280px;
                        padding: 0px 0 90px !important;
                    }
                    .cpa-top-buttons {
                        padding-top: 1rem !important;
                    }
                    .offer-boxes {
                        padding: 1rem!important;
                    }
                    .MuiPopover-paper {
                        max-width:100% !important;
                        width: calc(100% - 55px) !important;
                    }
                }
                .offer-boxes {
                    width:100% !important;
                    height:100% !important;
                }
                .bg-icon-blue {
                    background-color: #e5f3fe !important;
                }
                .bg-icon-yellow {
                    background-color: #fffdc9 !important;
                }
                .bg-icon-green, .bg-icon-red, .bg-icon-blue, .bg-icon-yellow {
                    padding: 12px;
                }
                .offer-total-title {
                    font-size:14px!important;
                }
                .MuiListItem-root.Mui-disabled {
                    opacity: 1 !important;
                    cursor: not-allowed !important;
                }
                .MuiListItem-root.Mui-disabled * {
                    pointer-events: none !important;
                }
            `}</style>
        </>
    );
}